import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { SupportedFileInput, UploadClient } from '@uploadcare/upload-client';

export default function useUploadToUploadCare() {
  const [progressCount, setProgressCount] = useState(0);

  const client = new UploadClient({
    publicKey: import.meta.env.VITE_APP_UPLOADCARE_KEY,
  });

  const onProgress: (args: any) => any = ({ value }: { value: number }) => {
    const loadingProgress = Math.ceil(value * 100);
    setProgressCount(loadingProgress);
  };

  const mutation = useMutation({
    mutationFn: async (payload: SupportedFileInput[]) => {
      const res = await client.uploadFileGroup(payload, { onProgress });

      return res;
    },
  });

  return { progressCount, ...mutation };
}
